import { isClassicWorkspaceById } from '@ane/exp-data/lib/utils/ManagementGroup';
import { ClusterScale as SynapseClusterScale, getSynapseValidateMessage, } from '../components/SynapseSubCluster/SynapseSubClusterComponent';
import { ComputeType } from '../../../../models/ComputeAbstract';
import { AuthenticationType } from '../../../constants/ComputeResource.constants';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
export const getValidateMessage = (name, value) => {
    if (!value || '' === value.toString().trim()) {
        return `${name} required`;
    }
    switch (name.toLowerCase()) {
        case 'fixedworkers':
        case 'minworkers':
        case 'maxworkers':
        case 'maxconcurrency':
            if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
                return 'Please enter an integer greater than 0';
            }
            else {
                return '';
            }
        case 'cluster':
            if (!/^cosmos[0-9]{2}$/.test(value)) {
                return 'The field cluster must match the placeholder expression. e.g. cosmos09';
            }
            else {
                return '';
            }
        case 'name':
            if (!/^[a-z0-9_.-]{1,128}$/.test(value)) {
                return 'Name is invalid. Only lowercase alphanumeric characters, hyphens, and underscores are allowed.';
            }
            else {
                return '';
            }
        case 'vcname':
            if (!/^[\w][\w.-]{0,50}$/.test(value)) {
                return 'Please enter a valid compute name.';
            }
            else {
                return '';
            }
        case 'keyvaulturl':
        case 'developmenturl':
            try {
                new URL(value);
            }
            catch (_) {
                return 'Require url';
            }
            return '';
        default:
            return '';
    }
};
export const validateMinMaxWorkers = (minworkersString, maxworkersString) => {
    if (minworkersString && maxworkersString) {
        const minworkers = Number.parseInt(minworkersString);
        const maxworkers = Number.parseInt(maxworkersString);
        if (!isNaN(maxworkers) && !isNaN(minworkers) && minworkers > maxworkers) {
            return 'Values of maxworkers is less than minworkers';
        }
    }
    return '';
};
export const validateSparkComputeType = (sparkComputeType) => {
    let validSparkComputeType = Object.keys(ComputeType)
        .map((key) => ComputeType[key])
        .filter((value) => typeof value === 'string');
    return validSparkComputeType.filter((computeType) => sparkComputeType === computeType).length === 0;
};
export const validateBasicInfo = (values, props) => {
    const isClassicWorkspace = isClassicWorkspaceById(props.workspaceId ? props.workspaceId : '');
    const errors = {};
    if (getValidateMessage('Name', values.name) !== '')
        errors.name = 'Required';
    if (validateSparkComputeType(values.sparkComputeType)) {
        errors.sparkComputeType = 'Required';
    }
    if (values.sparkComputeType && values.sparkComputeType === ComputeType.CosmosVC) {
        if (getValidateMessage('Cluster', values.cluster) !== '')
            errors.cluster = 'Required';
        if (getValidateMessage('VCName', values.vcName) !== '')
            errors.vcName = 'Required';
    }
    if (values.sparkComputeType && values.sparkComputeType === ComputeType.BlueshiftADLA) {
        if (getValidateMessage('adlaAccountName', values.adlaAccountName) !== '')
            errors.adlaAccountName = 'Required';
        if (getValidateMessage('defaultStorageAccountName', values.defaultStorageAccountName) !== '')
            errors.defaultStorageAccountName = 'Required';
        if (showMSIOption(props.workspaceId) &&
            ((!values.authenticationType && !values.servicePrincipalName) ||
                values.authenticationType === AuthenticationType.ManagedIdentity)) {
            if (getValidateMessage('managedIdentityId', values.managedIdentityId) !== '')
                errors.managedIdentityId = 'Required';
        }
        else if (values.authenticationType === AuthenticationType.ServicePrincipal ||
            (!showMSIOption(props.workspaceId) && !values.authenticationType && !values.managedIdentityId)) {
            if (getValidateMessage('servicePrincipalName', values.servicePrincipalName) !== '')
                errors.servicePrincipalName = 'Required';
        }
    }
    else if (values.sparkComputeType && values.sparkComputeType === ComputeType.Synapse) {
        if (showMSIOption(props.workspaceId) &&
            (!values.authenticationType || values.authenticationType === AuthenticationType.ManagedIdentity)) {
            if (getValidateMessage('managedIdentityId', values.managedIdentityId) !== '')
                errors.managedIdentityId = 'Required';
        }
    }
    else if (values.sparkComputeType && values.sparkComputeType === ComputeType.CosmosVC) {
        if (showMSIOption(props.workspaceId) &&
            (!values.authenticationType || values.authenticationType === AuthenticationType.ManagedIdentity)) {
            if (getValidateMessage('managedIdentityId', values.managedIdentityId) !== '')
                errors.managedIdentityId = 'Required';
        }
    }
    /**
     * CT classic workspace fields
     */
    if (!!isClassicWorkspace) {
        if (!values.owners || values.owners.length === 0) {
            errors.owners = 'Required';
        }
    }
    console.log('errors:', errors);
    return errors;
};
const validateSynapse = (subClusterList) => {
    if (!subClusterList || subClusterList.length === 0)
        return true;
    let error = false;
    subClusterList.forEach((subCluster) => {
        if (getSynapseValidateMessage('Name', subCluster.Name) !== '')
            error = true;
        if (getSynapseValidateMessage('DevelopmentUrl', subCluster.DevelopmentUrl) !== '')
            error = true;
        if (getSynapseValidateMessage('StorageAccount', subCluster.StorageAccount) !== '')
            error = true;
        if (getSynapseValidateMessage('StorageContainer', subCluster.StorageContainer) !== '')
            error = true;
        if (getSynapseValidateMessage('PoolName', subCluster.PoolName) !== '')
            error = true;
        if (getSynapseValidateMessage('MaxConcurrency', subCluster.MaxConcurrency) !== '')
            error = true;
        if (getSynapseValidateMessage('NodeSize', subCluster.NodeSize) !== '')
            error = true;
        if (subCluster.ScaleType === SynapseClusterScale.Fixed) {
            if (getSynapseValidateMessage('FixedWorkers', subCluster.FixedWorkers) !== '')
                error = true;
        }
        else if (subCluster.ScaleType === SynapseClusterScale.AutoScaling) {
            if (getSynapseValidateMessage('MinWorkers', subCluster.MinWorkers) !== '')
                error = true;
            if (getSynapseValidateMessage('MaxWorkers', subCluster.MaxWorkers) !== '')
                error = true;
            const minWorkers = subCluster.MinWorkers === '' ? '1' : subCluster.MinWorkers;
            const maxWorkers = subCluster.MaxWorkers === '' ? Number.MAX_SAFE_INTEGER.toString() : subCluster.MaxWorkers;
            if (validateMinMaxWorkers(minWorkers, maxWorkers) !== '')
                error = true;
        }
        else {
            error = true;
        }
        if (getSynapseValidateMessage('SparkVersion', subCluster.SparkVersion) !== '')
            error = true;
    });
    return error;
};
export const validateSubCluster = (values, existingErrors) => {
    if (values.sparkComputeType === ComputeType.Synapse) {
        if (validateSynapse(values.synapseSubClusterList))
            existingErrors.synapseSubClusterList = 'Error in synapse';
    }
    else if (values.sparkComputeType === ComputeType.CosmosVC) {
        if (values.maxConcurrency &&
            values.maxConcurrency.trim() !== '' &&
            getValidateMessage('MaxConcurrency', values.maxConcurrency) !== '')
            existingErrors.maxConcurrency = 'Error in max concurrency';
    }
    else if (values.sparkComputeType === ComputeType.BlueshiftADLA) {
        if (values.maxConcurrency &&
            values.maxConcurrency.trim() !== '' &&
            getValidateMessage('MaxConcurrency', values.maxConcurrency) !== '')
            existingErrors.maxConcurrency = 'Error in max concurrency';
    }
    else {
        existingErrors.sparkComputeType = 'Required spark compute type';
    }
    return existingErrors;
};
export const showMSIOption = (workspaceId) => {
    return EnvironmentService.enableMSIForCMS() && !isClassicWorkspaceById(workspaceId);
};

//# sourceMappingURL=ComputeFormikSettingsUtils.js.map
